import React, {Component} from 'react';
import Fade from 'react-reveal/Fade';
import styles from './css-modules/cross_fade_images.module.css';

class CrossFadeImages extends Component {
  render() {
    return (
      <div className={styles.crossFade_container}>
        <Fade when={this.props.time === 'Then'}>
          <div onClick={() => this.props.setDisplayedOverlay(this.props.overlayIDs.then)} style={this.props.time === 'Then' && {zIndex: 2}} className={styles.crossFade_Image_container}>
            <img src={this.props.images.then} className={styles.crossFade_image}></img>
          </div>
        </Fade>
        <Fade when={this.props.time === 'Now'}>
          <div onClick={() => this.props.setDisplayedOverlay(this.props.overlayIDs.now)} style={this.props.time === 'Now' && {zIndex: 2}} className={styles.crossFade_Image_container}>
            <img src={this.props.images.now} className={styles.crossFade_image}></img>
          </div>
        </Fade>
      </div>
    )
  }
}

export default CrossFadeImages;
